import { NavigationItem } from 'models/NavigationItem';
import { NotifyLink } from 'components/Shared/NotifyLink';
import { Header } from './header';
import { Item } from './item';
import { useDispatch } from 'react-redux';
import { GtmHeaderNavClick } from 'store/googleTagManager/actions';

export const ItemBlock = ({ type: _, ...i }: NavigationItem) => {
  const reduxDispatch = useDispatch();

  const handleOnClick = () => {
    reduxDispatch(GtmHeaderNavClick(i.url));
  };

  return (
    <Item>
      <Header>
        <NotifyLink onClick={handleOnClick} ticket={i.ticket} url={i.url}>
          <span>{i.title}</span>
          <span>{i.subtitle}</span>
        </NotifyLink>
      </Header>
    </Item>
  );
};
